module.exports = __webpack_public_path__ + "img/upgrade.2a7f264d.png";